module.exports = __webpack_public_path__ + "img/wx.85c73ee7.jpg";